function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import URI from 'urijs';
import Backbone from '@polleverywhere/backbone';
import Archive from './archive';

var ArchiveCollection = /*#__PURE__*/function (_Backbone$Collection) {
  _inheritsLoose(ArchiveCollection, _Backbone$Collection);

  function ArchiveCollection() {
    return _Backbone$Collection.apply(this, arguments) || this;
  }

  var _proto = ArchiveCollection.prototype;

  _proto.comparator = function comparator(archive) {
    return -archive.id;
  };
  /**
   * Initializer
   * @param {Array} models List of serialized objects or Archive models.
   * @param {Object} options Configurable options
   * @param {Backbone.Model} options.activity Activity model
   */


  _proto.initialize = function initialize(models, options) {
    if (models === void 0) {
      models = [];
    }

    if (options === void 0) {
      options = {};
    }

    this.options = Object.assign({}, options);
  };

  _proto.url = function url() {
    if (!this.activity) {
      throw new Error('Activity must be provided');
    }

    return URI(this.activity.url()).segment('archives').toString();
  };

  _createClass(ArchiveCollection, [{
    key: "model",
    get: function get() {
      return Archive;
    }
  }, {
    key: "activity",
    get: function get() {
      return this.options.activity;
    }
  }]);

  return ArchiveCollection;
}(Backbone.Collection);

export { ArchiveCollection as default };